<script lang="ts" setup>
import { Statistics } from '@/models/statistics.model';
import statisticsService from '@/services/statistics.service';

import { onMounted, ref } from 'vue';

const data = ref<Statistics[]>([]);

onMounted(async () => {
  const d = await statisticsService.userCo2Footprints();
  data.value = d;
});
</script>
<template>
  <v-container>
    <h2>CO₂ Footprint</h2>
    <p>This shows the amount of users in specific brackets of CO₂ footprint.</p>
    <v-frappe-chart
      type="bar"
      :labels="data.map((d) => d.label)"
      :data="[
        {
          name: data[0]?.stackedValues[0].label || '',
          values: data.map((d) => d.stackedValues[0].value),
        },
      ]"
      :height="300"
      :colors="['orange']"
    />
  </v-container>
</template>
